<script>
export default {
  name: "vendors_address",
  props: {
    wastesOrServiceBySchedule: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    addresses() {
      let addressArray = 
       this.wastesOrServiceBySchedule.map(waste_or_services_by_schedule => {
        return [
          this.$helpers.formatZipCode(waste_or_services_by_schedule?.waste_or_service_by_work_order.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.zip),
          waste_or_services_by_schedule?.waste_or_service_by_work_order.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.address_1,
          waste_or_services_by_schedule?.waste_or_service_by_work_order.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.address_2,
          waste_or_services_by_schedule?.waste_or_service_by_work_order.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.address_3,
          waste_or_services_by_schedule?.waste_or_service_by_work_order.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.address_4,
        ].filter(x => !!x).join('')
      }).filter(x => !!x);
      let addressSet = new Set(addressArray);
      return Array.from(addressSet).join('<br>');
    },
  }
}
</script>

<template>
  <div v-if="addresses" v-html="addresses" class="content-area"></div>
</template>

<style scoped lang="scss">
.content-area {
  padding: 10px;
  background: #f8f9fa;
  width: 100%;
}
</style>
